import React, { Component } from 'react';
import Sticky from 'Components/Sticky';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ReactComponent as BackIcon } from 'Icons/back.svg';
import { FETCH_SEEKER_BIDS } from 'Constants/actionConstants';
import { RFQ_DISPLAY_LIMIT } from 'Constants/commonConstants';
// import KPTLImg from 'Icons/kptl-logo.png';
import LogoImg from 'Icons/Logo.jpg';
import Pdf from "react-to-pdf";
import { numberWithCommas } from 'Utils';
import Moment from 'moment';

const pdfRef = React.createRef();

class POFormat extends Component {
    constructor(){
        super();
        this.state = {

        }
    }

    componentDidMount() {
        this.getSeekerBids();
    }

    getSeekerBids = () => {
		const { dispatch, match } = this.props;
		dispatch({
			type: FETCH_SEEKER_BIDS,
			params: {
				rfqId: match.params.id,
				rfqType: match.params.type,
				limit: RFQ_DISPLAY_LIMIT,
                type: match.params.approverType || undefined
			}
        })
	}

    getDetails = () => {
        const { trips, match, rfq } = this.props;
        console.log('rfq', rfq);
        let total = 0, bid = {};
        return (
            <>
                <div className={'col-1 ph-20 flex flex-middle'}>
                    <div className={'col-2 inBlock'}>
                        <img src={LogoImg} alt="" width='300' className={'ml-10'} height={'100'}/>
                    </div>
                    <div className={'col-2 inBlock tCenter'}>
                        {/* <div className={'fBold fs-16'}>{'KALPATARU POWER TRANSMISSION LTD.'}</div>
                        <div className={'mt-5 fs-14'}>Immeuble Hajal Massad Centre, 3rd Floor</div>
                        <div className={'mt-5 fs-14'}>Chambre 302 / 303, Carrefour Warda,</div>
                        <div className={'mt-5 fs-14'}>Yaounde, Republic of Cameroon</div> */}
                        <div className={'fBold fs-16'}>{'ABC LTD.'}</div>
                        <div className={'mt-5 fs-14'}>Bangalore, Karnataka, India</div>
                        {/* <div className={'mt-5 fs-14'}>Chambre 302 / 303, Carrefour Warda,</div> */}
                    </div>
                </div>
                
                {rfq && (trips || []).length > 0 && 
                <>
                <div className="mt-20 ph-20 pr-table col-1">
                <table cellPadding="0" cellSpacing="0" width="98%">
                    <tbody>
                    <tr><th style={{ 'borderRight': '1px solid grey'}}>{`PR REF:- ${rfq.requisitionNumber} /  / ${rfq.prDate && Moment(rfq.prDate).format('DD.MM.YYYY')}`}</th></tr>
                        <tr><th style={{ 'borderRight': '1px solid grey', 'textAlign': 'left'}}>PURCHASE ORDER</th></tr>
                        <tr><th style={{ 'borderRight': '1px solid grey', 'textAlign': 'left'}}>{((((trips[0] || {}).bids || []).find(bid => bid.orderText == (match.params || {}).order) || {}).transporterName || '').toUpperCase()}</th></tr>
                        <tr><th style={{ 'borderRight': '1px solid grey', 'textAlign': 'left'}}>{'We are please to place the order for the below mentioned items.'}</th></tr>
                        <tr><th style={{ 'borderRight': '1px solid grey', 'textAlign': 'left', 'padding': '10px'}}></th></tr>
                    </tbody>
                </table>
                </div>
                <div className="ph-20 pr-table col-1">
                    <table cellPadding="0" cellSpacing="0" width="98%">
                        <thead>
                        <tr>
                            <th>Sr No.</th>
                            <th>Description</th>
                            <th>UOM</th>
                            <th>Quantity</th>
                            <th>Rate</th>
                            <th>Total Amount</th>
                            <th>PR No.</th>
                            <th style={{ 'borderRight': '1px solid grey'}}>Location</th>
                        </tr>
                        </thead>
                        <tbody>
                        {(trips || []).map((trip, tripIndex) => {
                        bid = (trip.bids || []).find(bid => bid.orderText == (match.params || {}).order) || {};
                        total += (trip.total_estimated_qty || 0) * (bid.price || 0);
                        return ( <tr key={tripIndex}>
                            <td>{tripIndex + 1}</td>
                            <td>{trip.material_code_description || 0}</td>
                            <td>{trip.uom || 0}</td>
                            <td>{trip.total_estimated_qty || 0}</td>
                            <td>{bid.price}</td>
                            <td>{(trip.total_estimated_qty || 0) * (bid.price || 0) && numberWithCommas((trip.total_estimated_qty || 0) * (bid.price || 0))}</td>
                            <td>{rfq.pr_number || '-'}</td>
                            <td style={{ 'borderRight': '1px solid grey'}}>{rfq.location || '-'}</td>
                        </tr>)})}
                        <tr>
                            <th colSpan="4"></th>
                            <th>Total</th>
                            <th>{total && numberWithCommas(total)}</th>
                            <td colSpan="2" style={{ 'borderRight': '1px solid grey'}}></td>
                        </tr>
                        <tr>
                            <th colSpan="4"></th>
                            <th>TVA</th>
                            <th>{}</th>
                            <td colSpan="2" style={{ 'borderRight': '1px solid grey'}}></td>
                        </tr>
                        <tr>
                            <th colSpan="4"></th>
                            <th>Total TTC</th>
                            <th>{total && numberWithCommas(total)}</th>
                            <td colSpan="2" style={{ 'borderRight': '1px solid grey'}}></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="mt-20 ph-20 pr-table col-1">
                <table cellPadding="0" cellSpacing="0" width="98%">
                    <tbody>
                        <tr><th style={{ 'borderRight': '1px solid grey', 'textAlign': 'left'}}>Delivery Period: {rfq.deliveryDays.value} {' '} {rfq.deliveryDays.name}</th></tr>
                        <tr><th style={{ 'borderRight': '1px solid grey', 'textAlign': 'left'}}>Payment Terms: {rfq.payment_terms_name}</th></tr>
                        <tr><th style={{ 'borderRight': '1px solid grey', 'textAlign': 'left'}}>Mode Of Dispatch: {rfq.rfqDetails.serviceModeName}</th></tr>
                        <tr><th style={{ 'borderRight': '1px solid grey', 'textAlign': 'left'}}>Dispatch Destination: {rfq.dispatchDestination}</th></tr>
                        <tr><th style={{ 'borderRight': '1px solid grey', 'textAlign': 'left'}}>Contact Person: {rfq.contactPersonAtSite} {' '} {rfq.contactPersonNumberAtSite}</th></tr>
                    </tbody>
                </table>
                </div>
                <div className="mt-20 ph-20 pr-table col-1">
                <table cellPadding="0" cellSpacing="0" width="98%">
                    <thead>
                        <th>Reviewed By</th>
                        <th>Reviewed By</th>
                        <th>Approved By</th>
                        <th style={{ 'borderRight': '1px solid grey'}}>Accepted By</th>
                    </thead>
                    <tbody>
                        <td>
                            <div><b>{bid.bid_approved_status && bid.bid_approved_status[0] && bid.bid_approved_status[0].approved_by}</b></div>
                            <div>{bid.bid_approved_status && bid.bid_approved_status[0] && bid.bid_approved_status[0].loi_approved_date && Moment(bid.bid_approved_status[0].loi_approved_date).format('DD MMM YYYY hh:mm a')}</div>
                        </td>
                        <td>
                            <div><b>{ bid.bid_approved_status && bid.bid_approved_status[1] && bid.bid_approved_status[1].approved_by}</b></div>
                            <div>{bid.bid_approved_status && bid.bid_approved_status[1] && bid.bid_approved_status[1].loi_approved_date && Moment(bid.bid_approved_status[1].loi_approved_date).format('DD MMM YYYY hh:mm a')}</div>
                        </td>
                        <td>
                            <div><b>{bid.bid_approved_status && bid.bid_approved_status[2] && bid.bid_approved_status[2].approved_by}</b></div>
                            <div>{bid.bid_approved_status && bid.bid_approved_status[2] && bid.bid_approved_status[2].loi_approved_date && Moment(bid.bid_approved_status[2].loi_approved_date).format('DD MMM YYYY hh:mm a')}</div>
                        </td>
                        <td style={{ 'borderRight': '1px solid grey'}}>
                            <div><b>{bid.isLoiSent && bid.isAccept && bid.transporterName}</b></div>
                            <div>{bid.loi_accepted_date && Moment(bid.loi_accepted_date).format('DD MMM YYYY hh:mm a')}</div>
                        </td>
                    </tbody>
                </table>
                </div>
                </>
            }
            </>
        )
    }

    render() {
        const { rfq, trips } = this.props;
        const vendorTotal = {};
        return (
            <Sticky>
                {rfq && <Link className="ht-40 flex pl-40 wt-200 pt-10" to={"/seeker/bids/" + rfq.id + "/" + rfq.type}>
                    <BackIcon className="mr-10 fill-theme curP"/>
                    <div className="header-dark-color fs-16 fBold">{rfq.rfqDetails.name}</div>
                </Link>}
                <div className={'pv-20 mr-20 ml-20 col-1 box-shadow'} >
                    {this.getDetails()}
                </div>
                <div className="pl-40 pf col-1 b-0 ht-60 box-shadow bg-white z-6">
                    <div className="flex flex-middle flex-between ht-60">
                        <Pdf id="pdf-button" targetRef={pdfRef} filename="PO_format.pdf" options={{
                            orientation: 'landscape'
                        }}>
                            {({ toPdf }) => <button className={"ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30"} onClick={toPdf}>Download</button>}
                        </Pdf>
                    </div>
                    {<div style={{'width': '87%'}} ref={pdfRef}>
                        {this.getDetails()}
                    </div>}
                </div>
            </Sticky>
        )
    }
}

const mapStateToProps = ({ rfq }) => {
    return {
        trips: rfq.seekerBids.trips,
        rfq: rfq.seekerBids.data
    }
}

export default connect(mapStateToProps)(POFormat);
